import { createMiddleware } from "@tanstack/react-start";
import { getSupabase } from "@/lib/supabase-lazy";

/**
 * Lazy replacement for the generated `attachSupabaseAuth` middleware.
 *
 * Behaviour is identical — every server-function RPC still carries the current
 * bearer token — but the Supabase client is imported on first use instead of
 * being pulled into the initial bundle through `src/start.ts`, which put it in
 * the critical path of pages that make no RPC at all before first paint.
 */
export const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    const supabase = await getSupabase();
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
);
